import { render, staticRenderFns } from "./UpdateFeatures.vue?vue&type=template&id=595a6537"
import script from "./UpdateFeatures.vue?vue&type=script&lang=js"
export * from "./UpdateFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports